import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Initialize i18next
i18n
  // Load translations from the /public/locales folder
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Default language
    fallbackLng: 'en',
    // Debug mode in development
    debug: process.env.NODE_ENV === 'development',
    // Supported languages
    supportedLngs: ['en', 'vi', 'da', 'pl', 'uk'],
    // Namespace for translations
    ns: ['translation'],
    defaultNS: 'translation',
    // Detect language from browser
    detection: {
      // Order of detection methods
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      // Look for 'lng' in the query string
      lookupQuerystring: 'lng',
      // Store language in cookies
      lookupCookie: 'i18next',
      // Store language in localStorage
      lookupLocalStorage: 'i18nextLng',
      // Cache language detection
      caches: ['localStorage', 'cookie'],
      // HTML tag to detect language
      htmlTag: document.documentElement,
    },
    // Interpolation options
    interpolation: {
      // React already escapes values
      escapeValue: false,
    },
    // React options
    react: {
      // Wait for translations to be loaded
      useSuspense: true,
    },
  });

// Map language codes to their full names for UI display
export const languageNames: Record<string, string> = {
  en: 'English',
  vi: 'Tiếng Việt',
  da: 'Dansk',
  pl: 'Polski',
  uk: 'Українська',
};

export default i18n;
